export var Team;
(function (Team) {
    Team["BLUE"] = "blue";
    Team["RED"] = "red";
    Team["NEUTRAL"] = "neutral";
})(Team || (Team = {}));
(function (Team) {
    function getOpposite(team) {
        if (team === Team.NEUTRAL) {
            throw new Error('Cannot get opposite of neutral team');
        }
        return team === Team.BLUE ? Team.RED : Team.BLUE;
    }
    Team.getOpposite = getOpposite;
})(Team || (Team = {}));
export var BuffName;
(function (BuffName) {
    BuffName["RECALL"] = "recall";
    BuffName["EMPOWERED_RECALL"] = "empowered recall";
    BuffName["BARON"] = "baron";
    BuffName["ELDER"] = "elder";
    BuffName["BLUE"] = "blue";
    BuffName["RED"] = "red";
    BuffName["TELEPORT"] = "teleport";
    BuffName["TELEPORT_TARGET"] = "teleport target";
})(BuffName || (BuffName = {}));
export var SummonerSpellName;
(function (SummonerSpellName) {
    SummonerSpellName["BARRIER"] = "barrier";
    SummonerSpellName["CLEANSE"] = "cleanse";
    SummonerSpellName["EXHAUST"] = "exhaust";
    SummonerSpellName["FLASH"] = "flash";
    SummonerSpellName["GHOST"] = "ghost";
    SummonerSpellName["HEAL"] = "heal";
    SummonerSpellName["IGNITE"] = "ignite";
    SummonerSpellName["SMITE"] = "smite";
    SummonerSpellName["TELEPORT"] = "teleport";
})(SummonerSpellName || (SummonerSpellName = {}));
export var JungleCampName;
(function (JungleCampName) {
    JungleCampName["BLUE_GROMP"] = "blue gromp";
    JungleCampName["BLUE_BLUE"] = "blue blue";
    JungleCampName["BLUE_WOLVES"] = "blue wolves";
    JungleCampName["BLUE_RAPTORS"] = "blue raptors";
    JungleCampName["BLUE_RED"] = "blue red";
    JungleCampName["BLUE_KRUGS"] = "blue krugs";
    JungleCampName["RED_GROMP"] = "red gromp";
    JungleCampName["RED_BLUE"] = "red blue";
    JungleCampName["RED_WOLVES"] = "red wolves";
    JungleCampName["RED_RAPTORS"] = "red raptors";
    JungleCampName["RED_RED"] = "red red";
    JungleCampName["RED_KRUGS"] = "red krugs";
    JungleCampName["TOP_SCUTTLE"] = "top scuttle";
    JungleCampName["BOT_SCUTTLE"] = "bot scuttle";
    JungleCampName["GRUB_1"] = "grub 1";
    JungleCampName["GRUB_2"] = "grub 2";
    JungleCampName["GRUB_3"] = "grub 3";
    JungleCampName["RIFT_HERALD"] = "rift herald";
    JungleCampName["BARON"] = "baron";
    JungleCampName["DRAGON"] = "dragon";
})(JungleCampName || (JungleCampName = {}));
(function (JungleCampName) {
    function isEpic(jungleCampName) {
        return jungleCampName === JungleCampName.BARON || jungleCampName === JungleCampName.RIFT_HERALD || jungleCampName === JungleCampName.DRAGON || jungleCampName === JungleCampName.GRUB_1 || jungleCampName === JungleCampName.GRUB_2 || jungleCampName === JungleCampName.GRUB_3;
    }
    JungleCampName.isEpic = isEpic;
    function toEpicName(jungleCampName) {
        switch (jungleCampName) {
            case JungleCampName.BARON:
                return EpicName.BARON;
            case JungleCampName.RIFT_HERALD:
                return EpicName.RIFT_HERALD;
            case JungleCampName.GRUB_1:
            case JungleCampName.GRUB_2:
            case JungleCampName.GRUB_3:
                return EpicName.GRUB;
            case JungleCampName.DRAGON:
                return EpicName.DRAGON;
            default:
                throw new Error("Unknown epic name: ".concat(jungleCampName));
        }
    }
    JungleCampName.toEpicName = toEpicName;
})(JungleCampName || (JungleCampName = {}));
export var DragonType;
(function (DragonType) {
    DragonType["UNKNOWN"] = "unknown";
    DragonType["CLOUD"] = "cloud";
    DragonType["MOUNTAIN"] = "mountain";
    DragonType["OCEAN"] = "ocean";
    DragonType["INFERNAL"] = "infernal";
    DragonType["HEXTECH"] = "hextech";
    DragonType["CHEMTECH"] = "chemtech";
    DragonType["ELDER"] = "elder";
})(DragonType || (DragonType = {}));
export var MinionType;
(function (MinionType) {
    MinionType["MELEE"] = "melee";
    MinionType["RANGED"] = "ranged";
    MinionType["SIEGE"] = "siege";
    MinionType["SUPER"] = "super";
})(MinionType || (MinionType = {}));
export var Lane;
(function (Lane) {
    Lane["TOP"] = "top";
    Lane["MID"] = "mid";
    Lane["BOT"] = "bot";
})(Lane || (Lane = {}));
export var StructureType;
(function (StructureType) {
    StructureType["TURRET"] = "turret";
    StructureType["INHIB"] = "inhib";
})(StructureType || (StructureType = {}));
export var StructureTier;
(function (StructureTier) {
    StructureTier["NONE"] = "";
    StructureTier["OUTER"] = "outer";
    StructureTier["INNER"] = "inner";
    StructureTier["INHIB"] = "inhib";
    StructureTier["NEXUS_1"] = "nexus1";
    StructureTier["NEXUS_2"] = "nexus2";
})(StructureTier || (StructureTier = {}));
export var WardType;
(function (WardType) {
    WardType["STEALTH"] = "stealth";
    WardType["CONTROL"] = "control";
    WardType["FARSIGHT"] = "farsight";
    WardType["SCUTTLE"] = "scuttle";
    WardType["GHOSTPORO"] = "ghostporo";
    WardType["ZOMBIE"] = "zombie";
    WardType["FIDDLESTICKSEFFIGY"] = "fiddlestickseffigy";
})(WardType || (WardType = {}));
export var OtherName;
(function (OtherName) {
})(OtherName || (OtherName = {}));
export var EpicName;
(function (EpicName) {
    EpicName["BARON"] = "baron";
    EpicName["DRAGON"] = "dragon";
    EpicName["RIFT_HERALD"] = "rift herald";
    EpicName["GRUB"] = "grub";
})(EpicName || (EpicName = {}));
